var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSemilleroDeTalento = function SvgSemilleroDeTalento(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#semillero-de-talento_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.86 53.75H27.61v-3.19h2.12c5.86 0 10.62-4.77 10.62-10.62 0-1.17-.95-2.12-2.12-2.12h-4.25c-2.4 0-4.59.83-6.37 2.18v-1.12a2.121 2.121 0 0 0-4.24 0V40c-1.78-1.35-3.97-2.18-6.37-2.18h-4.25c-1.17 0-2.12.95-2.12 2.12 0 5.86 4.77 10.62 10.62 10.62h2.12v3.19H2.12C.95 53.75 0 54.7 0 55.87v3.19c0 2.93 2.38 5.31 5.31 5.31h40.37c2.93 0 5.31-2.38 5.31-5.31v-3.19c0-1.17-.95-2.12-2.12-2.12M34 42.06h1.76c-.88 2.47-3.24 4.25-6.01 4.25h-1.76c.88-2.47 3.24-4.25 6.01-4.25Zm-12.75 4.25c-2.77 0-5.13-1.78-6.01-4.25H17c2.77 0 5.13 1.78 6.01 4.25h-1.76Zm25.49 12.75c0 .59-.48 1.06-1.06 1.06H5.31c-.58 0-1.06-.48-1.06-1.06V58h42.49v1.06Z",
    fill: "#03F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.49 17.63c0 9.39-7.61 17-17 17s-17-7.61-17-17 7.62-17 17-17c9.38 0 17 7.61 17 17Z",
    fill: "#EB3D14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "semillero-de-talento_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .63)",
    d: "M0 0h50.99v63.74H0z"
  })))));
};
export default SvgSemilleroDeTalento;